"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiTwitter = function IconUiTwitter(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M3.51 38.561a24.732 24.732 0 0 0 13.56 3.965q11.456 0 18.652-8.175a24.833 24.833 0 0 0 6.511-16.987v-1.126a16.748 16.748 0 0 0 4.357-4.6 18.5 18.5 0 0 1-5.091 1.42 8.59 8.59 0 0 0 3.916-4.945 17.025 17.025 0 0 1-5.63 2.2 8.56 8.56 0 0 0-6.462-2.79 8.765 8.765 0 0 0-8.567 10.819A24 24 0 0 1 14.525 15.6 24.906 24.906 0 0 1 6.5 9.139a8.495 8.495 0 0 0-1.175 4.455A8.6 8.6 0 0 0 6.4 17.8a8.723 8.723 0 0 0 2.84 3.133 8.261 8.261 0 0 1-4.015-1.126v.1a8.686 8.686 0 0 0 2.055 5.681 8.231 8.231 0 0 0 5.042 3.035 8.566 8.566 0 0 1-2.35.294 10.768 10.768 0 0 1-1.664-.147 8.722 8.722 0 0 0 3.084 4.357 8.314 8.314 0 0 0 5.189 1.762 17.252 17.252 0 0 1-10.966 3.819 13.581 13.581 0 0 1-2.105-.147z"
  }));
};

IconUiTwitter.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiTwitter;
exports.default = _default;